import { CommonModule, DatePipe } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { EditorModule } from 'primeng/editor';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';
import { EcplArticleViewerComponent } from './ecpl-article-viewer.component';
import { KubaArticleViewerService } from './ecpl-article-viewer.service';
import { KubaBusyComponent } from '../../kuba/shared/components/busy/busy.component';

@NgModule({
  declarations: [EcplArticleViewerComponent],
  imports: [
    KubaBusyComponent,
    CommonModule,
    CKEditorModule,
    FormsModule,
    ReactiveFormsModule,
    DatePickerModule,
    InputNumberModule,
    TranslatePipe, TranslateDirective,
    SelectModule,
    MultiSelectModule,
    EditorModule,
    ContextMenuModule,
    MenuModule,
    TextareaModule,
    InputTextModule,
    ButtonModule,
    SharedModule,
    DialogModule,
    TabsModule,
  ],
  exports: [EcplArticleViewerComponent],
  providers: [DatePipe, KubaArticleViewerService],
})
export class EcplArticleViewerModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: EcplArticleViewerModule,
    };
  }
}
